<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.notiTempName')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.notiTempName") }}*</label>
                <vs-input type="text" v-model="form.name" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-2/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.notiTempTitle')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.notiTempTitle") }}*</label>
                <vs-input type="text" v-model="form.title" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/5 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.status") }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" name="status" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mt-5">
              <validation-provider :name="$t('sections.master.dataForm.notiTempDescription')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.master.dataForm.notiTempDescription')}}*</label>
                <vs-textarea v-model="form.description" rows="6" class="mt-2"/>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.master.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.master.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

import {IStatus} from "@/constants/interface";

const {mapActions: mapMasterActions, mapState: mapMasterFields } = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        name: '',
        title: '',
        description: '',
        status:  IStatus.enabled
      }
    }
  },
  async created () {
    const vm = this
    const { getNotificationTemplate } = vm
    await getNotificationTemplate({form: {id: vm.$route.params.id}})
    vm.pms ('MasterNotificationTemplate', 'edit', 'r')

    vm.form = {
      name: vm.notificationTemplate.name,
      title: vm.notificationTemplate.title,
      description: vm.notificationTemplate.description,
      status: vm.notificationTemplate.status
    }
  },
  computed: {
    ...mapMasterFields(['status', 'notificationTemplate']),
    ...mapGetters({
      statusesOptions :'Master/statusesOptions'
    })
  },
  methods: {
    ...mapMasterActions(['getNotificationTemplate', 'updateNotificationTemplate']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        this.updateNotificationTemplate({
          id: vm.$route.params.id,
          form: {
            name: vm.form.name,
            title: vm.form.title,
            description: vm.form.description,
            status: vm.form.status.value || vm.form.status
          },
          vm,
          redirect: "/master/notificationTemplate"
        })
      })
    },
    reset () {
      const vm = this
      vm.form = {
        name: vm.notificationTemplate.name,
        title: vm.notificationTemplate.title,
        description: vm.notificationTemplate.description,
        status: vm.notificationTemplate.status
      }
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  }
}
</script>
